import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Grid,
  makeStyles,
  MenuItem,
  Radio,
  Typography,
  Button,
  ButtonGroup
} from "@material-ui/core";
import { SelectValidator, TextValidator } from "react-material-ui-form-validator";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import CropFreeIcon from '@material-ui/icons/CropFree';
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import { parseISO } from 'date-fns';
import useScanDetection from 'use-scan-detection';
import { LETRA_TIPO_FACTURA_AFIP, TIPO_COMPROBANTE, TIPO_EFECTORES, TRAMITE_COMPROBANTE_FACTURACION_PROVEEDORES } from '../../../../../utils/constants';
import ValidatedDatePicker from '../../../../compartidos/ValidatedDatePicker';
import { startAlerta } from '../../../../../actions/ui/alertas';
import { PresupuestosForm } from './PresupuestosForm';
import { IntegracionForm } from './IntegracionForm';
import { limiteInput } from '../../../../../helpers/limiteInput';
import { autoFill } from '../../../../../helpers/autoFill';
import { CotizacionesForm } from './CotizacionesForm';
import { finishSpinner, startSpinner } from '../../../../../actions/ui/spinner';
import { useMesaEntrada } from '../../../../../hooks/useCases/useMesaEntrada';


const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.primary.main,
  },
  switchBase: {
    color: '#bdbdbd',
    '&$checked': {
      transform: 'translateX(16px)',
      color: '#4CAF50',
      '& + $track': {
        backgroundColor: '#3E8040',
        opacity: 1,
        border: 'none',
      },
    },
  },
  checked: {},
  track: {},
}));

function formatDate(date) {
  const parsedDate = parseISO(date);
  if (isNaN(parsedDate.getTime())) {
    return '';
  }

  return parsedDate;
}

export const PrestadoresForm = ({ formValues, handleInputChange, setearValor, setearVariosValores, presupuesto, cotizacion, setRestoCuenta, ospeDirecto }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { dataTransfer } = useMesaEntrada();
  
  const { tipoFactura, procedencia, tipoComprobante, tipoEfectorMenu, proformaTomada } = useSelector(state => state.mesaEntrada);
  const { dataContrato } = useSelector((state) => state.contrataciones);
  const { cuentas } = useSelector((state) => state.contratacionesDatosBancarios);

  const [startScan, setStartScan] = useState(false);

  const tipoComprobanteFilter =
    formValues.idTramite === TRAMITE_COMPROBANTE_FACTURACION_PROVEEDORES.COMPRAS_INSUMOS_MEDICOS
      ? tipoComprobante.filter(item => (item.id === TIPO_COMPROBANTE.FACTURA || item.id === TIPO_COMPROBANTE.RECIBO))
      : formValues.idTramite === TRAMITE_COMPROBANTE_FACTURACION_PROVEEDORES.RECIBO
        ? tipoComprobante.filter(item => (item.id === TIPO_COMPROBANTE.RECIBO))
        : tipoComprobante.filter(item => (item.id !== TIPO_COMPROBANTE.PRESUPUESTO && item.id !== TIPO_COMPROBANTE.COTIZACION));

  const menuPrestadores = tipoEfectorMenu === TIPO_EFECTORES.CONTRATO_PRESTADORES;
  const sinRecupero = dataTransfer.tramites.find(({idTramite}) => idTramite === formValues.idTramite)?.sinRecupero;

  //#region Scanner
  const handleScan = (code) => {
    if (code && startScan) {
      dispatch(startSpinner());
      if (code?.includes('https://www.arca.gob.ar/fe/qr/?p=') || 
          code?.includes('www.arca.gob.ar-fe-qr-Shift_p¿') ||
          code?.includes('https://www.afip.gob.ar/fe/qr/?p=') ||
          code?.includes('www.afip.gob.ar-fe-qr-Shift_p¿')) onChangeScan(code);

      else {
        dispatch(startAlerta('Qr invalido. Debe escanear factura de Afip', 'error'));
        dispatch(finishSpinner());
      }
    }
  }

  const onChangeScan = (str) => {
    debugger
    const regex = /Shift/g;
    let decoded_text = ''
    if (str.includes('www.arca.gob.ar')) {
      decoded_text = str.replace(regex, "").replace('httpsÑ--www.arca.gob.ar-fe-qr-_p¿', '').replace('https://www.arca.gob.ar/fe/qr/?p=', '');
    }
    else {
      decoded_text = str.replace(regex, "").replace('httpsÑ--www.afip.gob.ar-fe-qr-_p¿', '').replace('https://www.afip.gob.ar/fe/qr/?p=', '');
    }
    let cleanText;
    if (decoded_text.slice(-1) === "¿") {
      let endIndex = decoded_text.length - 1;
      while (decoded_text.charAt(endIndex - 1) === "¿") {
        endIndex--;
      }
      cleanText = decoded_text.slice(0, endIndex);
    } else {
      cleanText = decoded_text;
    }
    try {
      const data = atob(cleanText);
      const obj = JSON.parse(data);

      if (obj !== '') {
        if (
          (obj?.tipoCmp || obj?.TipoCmp) === LETRA_TIPO_FACTURA_AFIP.B ||
          (obj?.tipoCmp || obj?.TipoCmp) === LETRA_TIPO_FACTURA_AFIP.C
        ) {

          const fechaInicio = obj?.fecha ? formatDate(obj?.fecha) : formatDate(obj?.Fecha);
          setearVariosValores({
            totalComprobante:
              obj?.importe || obj?.Importe,
            caiCae:
              obj?.codAut || obj?.CodAut,
            nroSucursal:
              obj?.ptoVta.toString().padStart(5, '0') || obj?.PtoVta.toString().padStart(5, '0'),
            nroFactura:
              obj?.nroCmp.toString().padStart(8, '0') || obj?.NroCmp.toString().padStart(8, '0'),
            fechaInicioVigencia:
              fechaInicio,
            ...(cuentas.length === 1 ? {
              cuentasContables: [{
                idCuentaContable: cuentas[0].id,
                importeCuenta: obj?.importe || obj?.Importe,
                asignada: true
              }]
            } : {}
            )
          });
        } else {
          dispatch(startAlerta("Error de carga. El comprobante debe poseer Letra B o C", "error"));
        }
        dispatch(finishSpinner());
      }
    } catch (error) {
      dispatch(startAlerta("Error al escanear", "error"));
      dispatch(finishSpinner());
    }
  }

  useScanDetection({
    onComplete: handleScan,
    minLength: 3
  });
  // #endregion

  const handleTipoComprobante = (e) => {
    if (formValues.idTipoComprobante !== TIPO_COMPROBANTE.PROFORMA) {
      if (e.target.value === TIPO_COMPROBANTE.PROFORMA) {
        setearVariosValores({
          idTipoComprobante: e.target.value,
          nroSucursal: "99999",
          nroFactura: "",
          caiCae: ""
        });
      } else {
        handleInputChange(e)
      }
    } else {
      setearVariosValores({
        idTipoComprobante: e.target.value,
        nroSucursal: "",
        nroFactura: "",
        caiCae: ""
      });
    }
  }

  useEffect(() => {
    if (formValues.idTipoComprobante !== TIPO_COMPROBANTE.FACTURA)
      setearValor('internacion', '');
  }, [formValues.idTipoComprobante]);

  return (
    <>
      <Grid item xs={12}>
        <Grid container {...(!ospeDirecto ? { justify: 'center', alignItems: 'center' } : {})}>
          <Grid item xs={12} md={4} style={{ display: "flex", flexDirection: "column" }}>
            <Typography align="left" variant="button" color='secondary'>
              <span>Contrato:
                {ospeDirecto
                  ? <span className={classes.title}>{formValues?.razonSocial || formValues?.nombreFantasia}</span>
                  : <span className={classes.title}>{dataContrato?.razonSocial || dataContrato?.nombreFantasia}</span>
                }
              </span>
            </Typography>
            {presupuesto &&
              <Typography align="left" variant="button" color='secondary'>Afiliado: <span className={classes.title}>{presupuesto?.afiliado?.apellido_y_nombre}</span></Typography>
            }
            {cotizacion &&
              <Typography align="left" variant="button" color='secondary'>Afiliado: <span className={classes.title}>{cotizacion?.solicitud?.afiliado?.apellido_y_nombre}</span></Typography>
            }
          </Grid>
          {!ospeDirecto && (
            <Grid item xs={12} md={8} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <ButtonGroup
                disableElevation
                variant="contained"
                aria-label="Disabled elevation buttons"
              >
                <Button
                  variant="contained"
                  color="primary"
                  size="medium"
                  disabled={!startScan}
                  startIcon={<CropFreeIcon />}
                  onClick={() => {
                    setearVariosValores({
                      totalComprobante: "",
                      caiCae: "",
                      nroSucursal: "",
                      nroFactura: "",
                      fechaInicioVigencia: null
                    });
                    setStartScan(false);
                  }}
                >Desactivar</Button>
                <Button
                  variant="contained"
                  color="primary"
                  size="medium"
                  disabled={startScan}
                  startIcon={<CropFreeIcon />}
                  onClick={() => {
                    setearVariosValores({
                      totalComprobante: "",
                      caiCae: "",
                      nroSucursal: "",
                      nroFactura: "",
                      fechaInicioVigencia: null
                    });
                    setStartScan(true);
                  }}
                >Activar</Button>
              </ButtonGroup>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12} md={3}>
        <SelectValidator
          variant="outlined"
          fullWidth
          margin="normal"
          label="Tipo Comprobante"
          name="idTipoComprobante"
          value={formValues.idTipoComprobante}
          onChange={handleTipoComprobante}
          InputLabelProps={{ style: { fontWeight: 'bold' } }}
          validators={["required"]}
          errorMessages={["Este campo es obligatorio"]}
          disabled={(ospeDirecto || !!presupuesto || !!cotizacion || formValues.idTramite === TRAMITE_COMPROBANTE_FACTURACION_PROVEEDORES.RECIBO) ? true : false}
          style={{ color: '#000' }}
        >
          {presupuesto
            ? <MenuItem key={TIPO_COMPROBANTE.PRESUPUESTO} value={TIPO_COMPROBANTE.PRESUPUESTO} >{'Presupuesto'}</MenuItem>
            : cotizacion
              ? <MenuItem key={TIPO_COMPROBANTE.COTIZACION} value={TIPO_COMPROBANTE.COTIZACION} >{'Cotización'}</MenuItem>
              : proformaTomada
                ? tipoComprobanteFilter.filter(item => item.id !== TIPO_COMPROBANTE.PROFORMA).map((e) => <MenuItem key={e.id} value={e.id} >{e.descripcion}</MenuItem>)
                : tipoComprobanteFilter.map((e) => <MenuItem key={e.id} value={e.id} >{e.descripcion}</MenuItem>)
          }
        </SelectValidator>
      </Grid>
      <Grid item xs={12} md={3}>
        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
          <ValidatedDatePicker
            fullWidth
            margin="normal"
            label="Fecha Carga"
            format="dd/MM/yyyy"
            okLabel="Aceptar"
            maxDate={new Date()}
            clearLabel="Limpiar"
            cancelLabel="Cancelar"
            value={formValues.fechaCarga}
            onChange={(date) => {
              setearValor("fechaCarga", date);
            }}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
            disabled
          />
        </MuiPickersUtilsProvider>
      </Grid>
      <Grid item xs={12} md={3}>
        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
          <ValidatedDatePicker
            fullWidth
            margin="normal"
            label="Fecha Recepción"
            format="dd/MM/yyyy"
            okLabel="Aceptar"
            maxDate={new Date()}
            clearLabel="Limpiar"
            cancelLabel="Cancelar"
            value={formValues.fechaRecepcion}
            disabled={!!proformaTomada}
            onChange={(date) => {
              setearVariosValores({
                fechaRecepcion: date,
                fechaFinVigencia: moment(date).add(dataContrato?.plazoPago, 'days').format()
              })
            }}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
          />
        </MuiPickersUtilsProvider>
      </Grid>
      <Grid item xs={12} md={3}>
        <SelectValidator
          variant="outlined"
          fullWidth
          margin="normal"
          label="Procedencia"
          name="idProcedencia"
          value={formValues.idProcedencia}
          onChange={handleInputChange}
          disabled={ospeDirecto || !!proformaTomada}
          InputLabelProps={{ style: { fontWeight: 'bold' } }}
          validators={["required"]}
          errorMessages={["Este campo es obligatorio"]}
        >
          {procedencia.map((e) => <MenuItem key={e.id} value={e.id} >{e.descripcion}</MenuItem>)}
        </SelectValidator>
      </Grid>
      {/* {formValues.idTipoComprobante !== TIPO_COMPROBANTE.PROFORMA && */}
        <>
          <Grid item xs={12} md={2} >
            <SelectValidator
              variant="outlined"
              fullWidth
              margin="normal"
              label="Letra"
              name="idTipoFactura"
              value={formValues.idTipoFactura}
              onChange={handleInputChange}
              InputLabelProps={{ style: { fontWeight: 'bold' } }}
              validators={["required"]}
              errorMessages={["Este campo es obligatorio"]}
              disabled
            >
              {tipoFactura.map((e) => <MenuItem key={e.id} value={e.id} >{e.descripcion}</MenuItem>)}
            </SelectValidator>
          </Grid>
          <Grid item xs={12} md={2}>
            <TextValidator
              variant="outlined"
              margin='normal'
              fullWidth
              label="Número Sucursal"
              autoComplete="off"
              name="nroSucursal"
              type="number"
              disabled={!!proformaTomada || startScan}
              value={formValues.nroSucursal}
              onChange={e => {
                autoFill({
                  setearValor,
                  value: e.target.value,
                  num: 5,
                  name: "nroSucursal"
                })
              }}
              validators={[
                "required",
                "matchRegexp:^[0-9]{5,5}$"
              ]}
              errorMessages={[
                "Este campo es obligatorio",
                "Ingrese 5 dígitos."
              ]}
              InputLabelProps={{ style: { fontWeight: 'bold' } }}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <TextValidator
              variant="outlined"
              margin='normal'
              fullWidth
              label="Número Factura"
              autoComplete="off"
              name="nroFactura"
              type="number"
              disabled={!!proformaTomada || startScan || ospeDirecto}
              value={formValues.nroFactura}
              onChange={e => {
                autoFill({
                  setearValor,
                  value: e.target.value,
                  num: 8,
                  name: "nroFactura"
                })
              }}
              validators={[
                "required",
                "matchRegexp:^[0-9]{8,8}$"
              ]}
              errorMessages={[
                "Este campo es obligatorio",
                "Ingrese 7 dígitos."
              ]}
              InputLabelProps={{ style: { fontWeight: 'bold' } }}
            />
          </Grid>
        </>
      {/* } */}
      <Grid item xs={12} md={3}>
        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
          <ValidatedDatePicker
            fullWidth
            margin="normal"
            label="Fecha Comprobante"
            format="dd/MM/yyyy"
            okLabel="Aceptar"
            clearLabel="Limpiar"
            cancelLabel="Cancelar"
            value={formValues.fechaInicioVigencia}
            onChange={(date) => { setearValor("fechaInicioVigencia", date) }}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
            maxDate={new Date(formValues.fechaFinVigencia)}
            validators={["required", "isValidDate"]}
            errorMessages={["Este campo es obligatorio", "Fecha no válida"]}
            disabled={!!proformaTomada || !!cotizacion || startScan}
          />
        </MuiPickersUtilsProvider>
      </Grid>
      <Grid item xs={12} md={3}>
        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
          <ValidatedDatePicker
            fullWidth
            margin="normal"
            label="Fecha Vencimiento"
            format="dd/MM/yyyy"
            okLabel="Aceptar"
            clearLabel="Limpiar"
            cancelLabel="Cancelar"
            disabled={menuPrestadores || !!proformaTomada}
            value={formValues.fechaFinVigencia}
            onChange={(date) => {
              setearValor("fechaFinVigencia", date);
            }}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
            validators={["required", "isValidDate"]}
            errorMessages={["Este campo es obligatorio", "Fecha no válida"]}
            minDate={formValues.fechaInicioVigencia}
          />
        </MuiPickersUtilsProvider>
      </Grid>
      <Grid item xs={12} md={6}>
        <TextValidator
          variant="outlined"
          margin='normal'
          fullWidth
          label="Total Comprobante"
          autoComplete="off"
          name="totalComprobante"
          value={formValues.totalComprobante}
          onChange={(e) => {
            if (cuentas.length > 1) {
              handleInputChange(e);
              setRestoCuenta(parseFloat(e.target.value));
            } else if (cuentas.length === 1) {
              setearVariosValores({
                ...formValues,
                totalComprobante: e.target.value,
                cuentasContables: [{
                  idCuentaContable: cuentas[0].id,
                  importeCuenta: parseFloat(e.target.value),
                  asignada: true
                }]
              })
            } else {
              handleInputChange(e);
            }
          }}
          //type='number'
          validators={[
            "required",
            "isFloat",
          ]}
          errorMessages={[
            "Este campo es obligatorio",
            "Solo números",
          ]}
          InputLabelProps={{ style: { fontWeight: 'bold' } }}
          disabled={sinRecupero || tipoEfectorMenu === TIPO_EFECTORES.INTEGRACION || !!proformaTomada || !!cotizacion || startScan}
        />
      </Grid>
      {formValues.idTipoComprobante !== TIPO_COMPROBANTE.PROFORMA &&
        <Grid item xs={12} md={6}>
          <TextValidator
            variant="outlined"
            margin='normal'
            fullWidth
            label="CAI/CAE"
            autoComplete="off"
            name="caiCae"
            value={formValues.caiCae}
            disabled={startScan}
            onChange={e => {
              limiteInput({
                e, handleInputChange, setearValor,
                limit: 14,
                value: formValues.caiCae,
                name: "caiCae"
              })
            }}
            validators={[
              "isNumber",
              "maxNumber:99999999999999",
              "minNumber:9999999999999"
            ]}
            errorMessages={[
              "Solo números",
              "Ingrese 14 dígitos",
              "Ingrese 14 dígitos ",
            ]}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </Grid>
      }
      {formValues.idTipoComprobante === TIPO_COMPROBANTE.FACTURA &&
        <Grid item xs={12} style={{ display: "flex", justifyContent: "center", gap: "2em" }}>
          <div
            style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: !!proformaTomada ? "default" : "pointer" }}
            disabled={!!proformaTomada}
            onClick={() => {
              if (!proformaTomada) {
                if (formValues.ambulatoria) {
                  setearValor("ambulatoria", false)
                } else {
                  if (formValues.internacion) {
                    setearVariosValores({
                      ...formValues,
                      internacion: false,
                      ambulatoria: true
                    })
                  } else {
                    setearValor("ambulatoria", true)
                  }
                }
              }
            }}
          >
            <Radio
              checked={formValues.ambulatoria}
              disabled={!!proformaTomada}
              color="primary"
              name="radio-button-demo"
            />
            <Typography>Ambulatoria</Typography>
          </div>
          <div
            style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor:!!proformaTomada ? "default" : "pointer" }}
            disabled={!!proformaTomada}
            onClick={() => {
              if (!proformaTomada) {
                if (formValues.internacion) {
                  setearValor("internacion", false)
                } else {
                  if (formValues.ambulatoria) {
                    setearVariosValores({
                      ...formValues,
                      ambulatoria: false,
                      internacion: true
                    })
                  } else {
                    setearValor("internacion", true)
                  }
                }
              }
            }}
          >
            <Radio
              checked={formValues.internacion}
              disabled={!!proformaTomada}
              color="primary"
              name="radio-button-demo"
            />
            <Typography>Con Internación</Typography>
          </div>
        </Grid>
      }
      {formValues.idTipoComprobante === TIPO_COMPROBANTE.PRESUPUESTO &&
        <PresupuestosForm
          formValues={formValues}
          handleInputChange={handleInputChange}
        />
      }
      {formValues.idTipoComprobante === TIPO_COMPROBANTE.COTIZACION &&
        <CotizacionesForm
          formValues={formValues}
          handleInputChange={handleInputChange}
          cotizacion={cotizacion}
        />
      }
      {(sinRecupero || tipoEfectorMenu === TIPO_EFECTORES.INTEGRACION) &&
        <Grid item xs={12}>
          <Grid container justify='space-between' alignItems='center' spacing={1}>
            <IntegracionForm
              formValues={formValues}
              handleInputChange={handleInputChange}
              setearValor={setearValor}
              setearVariosValores={setearVariosValores}
              proforma={!!proformaTomada}
              ospeDirecto={ospeDirecto}
              sinRecupero={sinRecupero}
            />
          </Grid>
        </Grid>
      }
    </>
  )
}

